import React from 'react'
import type { SelectTabData, SelectTabEvent } from '@fluentui/react-components'
import { Button, TabList } from '@fluentui/react-components'
import { NavigationRegular } from '@fluentui/react-icons'
import { makeStyles } from '@fluentui/react-components'

const useStyles = makeStyles({
	footer: {
		position: 'fixed',
		bottom: '0',
		left: '0',
		right: '0',
		zIndex: '1000',
		backgroundColor: 'transparent',
		padding: '10px 20px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		pointerEvents: 'none' // Allow clicks to pass through empty areas
	},
	nav: {
		opacity: '0.75',
		pointerEvents: 'auto'
	},
	mobileNavButton: {
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		border: '1px solid rgba(255, 165, 0, 0.8)',
		borderRadius: '4px',
		color: 'white'
	},
	copyright: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		pointerEvents: 'auto'
	},
	spacer: {
		minWidth: '40px'
	},
	copyrightRow: {
		display: 'inline-flex',
		alignItems: 'center',
		columnGap: '8px'
	},
	flag: {
		height: '18px',
		width: 'auto',
		display: 'block',
		borderRadius: '2px',
		boxShadow: '0 0 2px rgba(0, 0, 0, 0.5)'
	}
})

// Five-pointed star (outer r 2.7) for the EU flag
const EU_STAR = 'M0,-2.7 L0.61,-0.83 L2.57,-0.83 L0.98,0.32 L1.59,2.18 L0,1.03 L-1.59,2.18 L-0.98,0.32 L-2.57,-0.83 L-0.61,-0.83 Z'

/** Inline SVG flags — emoji flags don't render on Windows browsers. */
const FlagCZ: React.FC<{ className?: string }> = ({ className }) => (
	<svg className={className} viewBox="0 0 36 24" role="img" aria-label="Czechia">
		<rect width="36" height="12" fill="#ffffff" />
		<rect y="12" width="36" height="12" fill="#d7141a" />
		<path d="M0,0 L18,12 L0,24 Z" fill="#11457e" />
	</svg>
)

const FlagEU: React.FC<{ className?: string }> = ({ className }) => (
	<svg className={className} viewBox="0 0 36 24" role="img" aria-label="European Union">
		<rect width="36" height="24" fill="#003399" />
		{Array.from({ length: 12 }, (_, i) => {
			const angle = (i * 30 * Math.PI) / 180
			const x = (18 + 8 * Math.sin(angle)).toFixed(2)
			const y = (12 - 8 * Math.cos(angle)).toFixed(2)
			return <path key={i} d={EU_STAR} fill="#ffcc00" transform={`translate(${x} ${y})`} />
		})}
	</svg>
)

interface AppFooterProps {
	isMobile: boolean
	location: { pathname: string }
	onTabSelect: (event: SelectTabEvent, data: SelectTabData) => void
	onDrawerOpen: () => void
	year?: number
}

export const AppFooter: React.FC<AppFooterProps> = ({
	isMobile,
	location,
	onTabSelect,
	onDrawerOpen,
	year,
}) => {
	const styles = useStyles()

	return (
		<footer className={`App-footer ${styles.footer}`}>
			<nav className={styles.nav}>
				{isMobile ? (
					<Button
						icon={<NavigationRegular />}
						onClick={onDrawerOpen}
						aria-label="Open navigation menu"
						className={styles.mobileNavButton}
					/>
				) : (
					<TabList selectedValue={location.pathname} onTabSelect={onTabSelect}>
						{/* <Tab value="/">Home</Tab> */}
						{/* <Tab value="/blog">Blog</Tab> */}
					</TabList>
				)}
			</nav>
			<div className={styles.copyright}>
				<div className={styles.copyrightRow}>
					<span>© {year} Martin Bondy Pětvalský</span>
					<FlagEU className={styles.flag} />
					<FlagCZ className={styles.flag} />
				</div>
			</div>
			{/* spacer keeps the copyright centered (switchers moved to top) */}
			<div className={styles.spacer} />
		</footer>
	)
}